<template>
    <option :value="optionValue" v-html="fieldsLabel"></option>
</template>
<script>
    import {fieldDisplay} from "./mixins/fieldDisplay";

    export default {
        props: {
            optionValue: {}
        },
        mixins:[fieldDisplay],
    }
</script>
